
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export function useApplicationDeleter(onRefresh: () => void) {
  const handleDeleteApplication = async (applicationId: string) => {
    if (!confirm("Are you sure you want to delete this application? This action cannot be undone.")) {
      return;
    }

    try {
      console.log(`🔄 Deleting application ${applicationId}...`);
      
      const { error: deleteExpertError } = await supabase
        .from("consultation_experts")
        .delete()
        .eq("application_id", applicationId);

      if (deleteExpertError && deleteExpertError.code !== 'PGRST116') {
        throw deleteExpertError;
      }

      const { error: deleteAppError } = await supabase
        .from("expert_applications")
        .delete()
        .eq("id", applicationId);

      if (deleteAppError) throw deleteAppError;

      console.log("✅ Application deleted successfully");
      toast.success("Application deleted successfully");
      onRefresh();
    } catch (error) {
      console.error("💥 Error deleting application:", error);
      toast.error("Failed to delete application");
    }
  };

  return { handleDeleteApplication };
}
